<div
	class="border border-2 border-solid d-flex justify-content-center align-items-center position-relative"
	style="border-color: #dadce0"
	[ngStyle]="uploaderDimensions()"
>
	@if (currentImage() || selectedImage()) {
		@if (!imageLoadingState()) {
			<img [src]="selectedImage()" [ngStyle]="uploaderDimensions()" />
		} @else {
			<mat-spinner></mat-spinner>
		}
	} @else {
		<span class="display-3">
			<i class="fas fa-ban"></i>
		</span>
	}
	<button
		type="button"
		class="position-absolute top-0 end-0"
		mat-raised-button
		(click)="fileInput.click()"
		matTooltip="Dodaj nowe zdjęcie"
	>
		<i class="fas fa-camera"></i>
	</button>
	@if (showSaveImageWarning()) {
		<span class="alert alert-warning position-absolute bottom-0 mb-0 w-100 rounded-0 opacity-75 custom-alert">
			Nie zapomnij zapisać zmian, aby zdjęcie zostało przypisane.
		</span>
	}
	<input hidden #fileInput type="file" id="file" accept="image/*" (change)="processImage($event)" />
	<ng-content select="[additionalContent]"></ng-content>
</div>
